import { reservationStatuses } from "@/app/dashboard/(logged-in)/components/values";

export function ReservationStatusBubble({ reservationStatus }: any) {
  const status = reservationStatuses.find(
    (status: any) => status.value === reservationStatus,
  );

  if (!status) {
    return null;
  }

  return (
    <div>
      {status.icon && (
        <status.icon className="mr-1 mt-0.5 h-4 w-4 text-muted-foreground" />
      )}
    </div>
  );
}
